/**
 * Workspace URL keys, one rule for every path that sets or routes one (architecture §18 row 10; registry
 * identity-workspace.onboarding.create-workspace AC6, identity-workspace.workspace.general-settings AC6): workspace
 * creation (invites-onboarding), the URL rename (account-profile) and the server's split between workspace paths and
 * top-level routes (apps/server/src/http/static.ts). W1 step 0: the two slices each had a copy, and only creation
 * refused reserved words, so a rename could have shadowed /login or /setup.
 */
export const URL_KEY_MIN = 2;
export const URL_KEY_MAX = 48;
export const URL_KEY_RE = /^[a-z0-9][a-z0-9-]{1,47}$/;

/** First path segments the SPA or the server use (or may use), so a workspace can never shadow them. */
export const RESERVED_URL_KEYS: ReadonlySet<string> = new Set([
  'access-removed',
  'admin',
  'api',
  'app',
  'assets',
  'auth',
  'create-or-join',
  'docs',
  'healthz',
  'help',
  'invite',
  'invites',
  'join',
  'livez',
  'login',
  'logout',
  'new',
  'no-workspace',
  'oauth',
  'settings',
  'setup',
  'static',
  'unsubscribe',
  'www',
]);

export type UrlKeyProblem = 'invalid' | 'reserved';

/** Why a (normalized, lowercase) key can't be a workspace URL, or null when it can (availability is the server's). */
export function urlKeyProblem(key: string): UrlKeyProblem | null {
  if (!URL_KEY_RE.test(key)) return 'invalid';
  if (RESERVED_URL_KEYS.has(key)) return 'reserved';
  return null;
}
